/**
 * @generated SignedSource<<89f3fe36fa2dfaae2bf0304cc56016c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailShipping_item$data = {
  readonly attributes: {
    readonly leadTime: ReadonlyArray<{
      readonly option: {
        readonly urlLabel: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipsFrom_item" | "PdpSharedShippingInfoWrapper_item" | "ShippingDetailsCustomsDisclaimer_item">;
  readonly " $fragmentType": "PdpSharedDetailShipping_item";
};
export type PdpSharedDetailShipping_item$key = {
  readonly " $data"?: PdpSharedDetailShipping_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailShipping_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipsFrom_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShippingDetailsCustomsDisclaimer_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "leadTime",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AttributeOption",
              "kind": "LinkedField",
              "name": "option",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "217eca88db80dd99c52dc0a9b895bd4b";

export default node;
